export default function formatToTitleCase(str) {
  if (!str) return "";
  return str
    .replace(/_/g, " ")               // replace _ with spaces
    .toLowerCase()                    // lowercase everything
    .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize each word
}
